







































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import jsZip from "jszip";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import AnswerImageArea from "../../components/AnswerImageArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import { Sheet, SheetField, PageItem, AnswerText, ParamSheetField, StudentSheetStatusEnum, PreviewImageTypeEnum, AnswerImage, QuestionImageDiscription } from "../../modules/digital_paper/AnswerInput"
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import heic2any from "heic2any";

export interface Data {
  initiarizedData: boolean
  student_sheet_id: string
  status: number
  times: number
  sheet: Sheet
  pageItems: PageItem[]
  base64QuestionImages: string[]
  base64CorrectImages: string[]
  direction: number
  selectedFieldIdx: number
  cutMargin: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  selectedAnswerPageIdx: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  selectedStamp: any
  drawMode: number
  DigitalAnswerTypeEnum: Readonly<{Both: number; Draw: number; Text: number;}>
  fontSize: number
  lineHeight: number
  modeAreaLeft: number
  modeAreaTop: number
  modeAreaWidth: number
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  before_student_sheet_id: number
  keyCode: string
  isShortcutKeyEnable: boolean
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  fromStudentSheetList: boolean
  remainingTime: number
  isRemainingTimeDisp: boolean
  timer: any
  isTimeOver: boolean
  isTimeOverAlertDisp: boolean
  isTextEnable: boolean
  isDrawEnable: boolean
  isImageEnable: boolean
  textColor: string
  drawColor: string
  thickness: number
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Completed: number;}>
  isScrolling: boolean
  scoringToolboxLeft: number
  scoringToolboxTop: number
  PreviewImageTypeEnum: Readonly<{None: number; Question: number; Correct: number;}>
  previewImageType: number
  isDispToggre: boolean
  isColorEnable: boolean
  questionImageDiscriptions: QuestionImageDiscription[]
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "answer-image-area": AnswerImageArea,
    "preview-image-area": PreviewImageArea,
    "text-edit-box": TextEditBox,
    "text-direction-toggle": TextDirectionToggle,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
  },
  setup(props, context){

    const DrawModeEnum = Common.DrawModeEnum;
    const DirectionEnum = Common.DirectionEnum;
    const StmapTypeEnum = Common.StmapTypeEnum;

    const horizonAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const verticalAnswerImageAreaRef = ref<InstanceType<typeof AnswerImageArea>>();
    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const verticalCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      student_sheet_id: null,
      status: null,
      times: null,
      sheet: null,
      pageItems: [],
      base64QuestionImages: [],
      base64CorrectImages: [],
      direction: DirectionEnum.Vertical,
      selectedFieldIdx: null,
      cutMargin: 0,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.5,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.5,
      separatorSize: 10,
      selectedAnswerPageIdx: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      selectedStamp: null,
      drawMode: DrawModeEnum.None,
      DigitalAnswerTypeEnum: Common.DigialAnswerTypeEnum,
      fontSize: 32,
      lineHeight: 0,
      modeAreaLeft: 0,
      modeAreaTop: 0,
      modeAreaWidth: 240,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      before_student_sheet_id: null,
      keyCode: null,
      isShortcutKeyEnable: true,
      pcHelpFields: [
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "テキストボックスを出力" },
        { key: "テキスト選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "テキストボックスを削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "設問青枠内を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小<br>（手書きモードで設問青枠内では使用できません）" },
      ],
      errors: [],
      fromStudentSheetList: false,
      remainingTime: null,
      timer: null,
      isTimeOver: false,
      isRemainingTimeDisp: false,
      isTimeOverAlertDisp: false,
      isTextEnable: false,
      isDrawEnable: false,
      isImageEnable: false,
      textColor: "#000000",
      drawColor: "#000000",
      thickness: 2,
      StudentSheetStatusEnum: StudentSheetStatusEnum,
      isScrolling: false,
      scoringToolboxLeft: 0,
      scoringToolboxTop: 0,
      PreviewImageTypeEnum: PreviewImageTypeEnum,
      previewImageType: PreviewImageTypeEnum.None,
      isDispToggre: false,
      isColorEnable: false,
      questionImageDiscriptions: [],
    });

    /************************************************************
     * 採点結果PDF表示
     ************************************************************/

    const downloadResultPdf = async () => {
      context.root.$store.dispatch("showOverlay");
      
      await http.get(`/api/digital_paper/student_sheet_list/download_result_pdf/${state.before_student_sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.target = "_blank"
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
        // state.modeAreaTop = (mainArea.offsetTop + 56);
        // state.modeAreaLeft = state.mainAreaWidth - state.modeAreaWidth - 20;
        // state.scoringToolboxTop = (mainArea.offsetTop + 56);
        // state.scoringToolboxLeft = state.mainAreaWidth - state.modeAreaWidth - 20;
        state.modeAreaTop = (mainArea.offsetTop + 56);
        const toolbox = document.getElementById("draw-mode-tool-box");
        const rightMargin = toolbox ? toolbox.clientWidth : 0;
        state.modeAreaLeft = state.mainAreaWidth - rightMargin - 20;
      }
    };

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const answerArea = document.getElementById(`answer-page-root-${state.direction}`);
      const mainArea = document.getElementById("main-area");

      const areaW = answerArea.clientWidth - 16;
      const areaH = mainArea.clientHeight - 80;

      if(answerArea && mainArea){
        let scaleW = areaW / state.pageItems[state.selectedAnswerPageIdx].base_width;
        let scaleH = areaH / state.pageItems[state.selectedAnswerPageIdx].base_height;
        let scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

        verticalAnswerImageAreaRef.value.inputScale = scale;
        horizonAnswerImageAreaRef.value.inputScale = scale;

        if(verticalCorrectImageAreaRef.value){
          verticalCorrectImageAreaRef.value.inputScale = scale;
        }

        if(horizonCorrectImageAreaRef.value){
          horizonCorrectImageAreaRef.value.inputScale = scale;
        }

        if(verticalQuestionImageAreaRef.value){
          scaleW = areaW / state.sheet.questionImageWidth;
          scaleH = areaH / state.sheet.questionImageHeight;
          scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;

          verticalQuestionImageAreaRef.value.inputScale = scale;
          horizonQuestionImageAreaRef.value.inputScale = scale;
        }
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      console.log("resizing");
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
    }

    /************************************************************
     * 横向きモードの上部エリアのheight
     ************************************************************/

    const horizonModeTopHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonTopHeightPer;
    });

    /************************************************************
     * 横向きモードの下部エリアのheight
     ************************************************************/

    const horizonModeBottomHeight = computed((): any => {
      return state.mainAreaHeight * state.horizonBottomHeightPer;
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        state.selectedStamp = null;

        context.root.$nextTick(() => {
          if(state.direction == DirectionEnum.Horizon){
            horizonAnswerImageAreaRef.value.renderCanvas();
          }else{
            verticalAnswerImageAreaRef.value.renderCanvas();
          }
        });
      }
    }

    /******************************
     * 解答用紙ページ切り替え時のemit
     ******************************/

    const answerSheetPageChanged = (idx: number) => {
      state.selectedAnswerPageIdx = idx;
      state.selectedStamp = null;
      state.selectedFieldIdx = null;
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答｀ページ切り替え時のemit
     ******************************/

    const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

    const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /******************************
     * 設問アイコンクリック時のemit
     ******************************/

    const changeSelectedSheetField = async (selectedFieldIdx: number) => {
      state.selectedFieldIdx = selectedFieldIdx;
      state.selectedStamp = null;

      if(state.status == StudentSheetStatusEnum.Answering){
        if(selectedSheetField.value){
          const baseElemId = `${state.direction}-${selectedSheetField.value.id}-parent`;
          const toolboxId = "draw-mode-tool-box";
          autoMoveToolbox(baseElemId, toolboxId, "modeAreaLeft", "modeAreaTop");
        }
      }else if(state.status == StudentSheetStatusEnum.SelfScoring){
        if(selectedSheetField.value){
          const baseElemId = `scoring-parent-${state.direction}-${selectedSheetField.value.id}`;
          const toolboxId = "scoring-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
        }
      }
    }

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedStampElemId = computed((): any => {
      if(!state.selectedStamp || !selectedSheetField.value){
        return null;
      }else{
        return `text-image-${state.direction}-${selectedSheetField.value.id}-${state.selectedStamp.idx}`;
      }
    });

    /************************************************************
     * 選択中の設問を返却
     ************************************************************/

    const selectedSheetField = computed((): SheetField => {
      if(state.selectedAnswerPageIdx != null && state.selectedFieldIdx != null){
        return state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx];
      }else{
        return null;
      }
    });

    const selectedTextDirection = computed((): number => {
      return context.root.$store.state.textDirection;
    });

    /************************************************************
     * 自己採点ツールボックスの表示判定
     ************************************************************/

    const isScoringToolBoxVisible = computed((): boolean => {
      return state.status == StudentSheetStatusEnum.SelfScoring && selectedSheetField.value != null && !state.isScrolling;
    });

    /************************************************************
     * 自己採点
     ************************************************************/

    const changeCorrectState = async (correct_state: number) => {
      selectedSheetField.value.correct_state = correct_state
      
      if(state.direction == DirectionEnum.Horizon){
        horizonAnswerImageAreaRef.value.$forceUpdate();
      }else{
        verticalAnswerImageAreaRef.value.$forceUpdate();
      }

      let isFieldChanged = false;

      const idx = state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields.indexOf(selectedSheetField.value);
      if(state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields.length > idx + 1){
        // 同ページの次の設問へ
        state.selectedFieldIdx += 1;
        isFieldChanged = true;
      }else if(state.pageItems.length > state.selectedAnswerPageIdx + 1){
        // 次のページの最初の設問へ
        state.selectedAnswerPageIdx += 1;
        state.selectedFieldIdx = state.pageItems[state.selectedAnswerPageIdx].scoreing_target_sheet_fields[0].idx;
        isFieldChanged = true;
      }

      // 次の設問位置へスクロールしてツールボックスを移動
      if(isFieldChanged){

        context.root.$nextTick(async () => {
          // マークの位置へスクロール
          const rectElement = document.getElementById(`scoring-parent-${state.direction}-${selectedSheetField.value.id}`);
          const imageArea = document.getElementById(`answer-page-root-${state.direction}`);

          const imageAreaWidth = imageArea.offsetWidth;
          const imageAreaHeight = imageArea.offsetHeight;
          const imageAreaTop = imageArea.scrollTop;
          const imageAreaBottom = imageAreaTop + imageAreaHeight;
          const imageAreaLeft = imageArea.scrollLeft;
          const imageAreaRight = imageArea.scrollLeft + imageAreaWidth;
          const rectTop = rectElement.offsetTop;
          const rectBottom = rectElement.offsetTop + rectElement.offsetHeight;
          const rectLeft = rectElement.offsetLeft;
          const rectRight = rectElement.offsetLeft + rectElement.offsetWidth;

          let fromTop = imageAreaTop;
          let toTop = imageAreaTop;
          let fromLeft = imageAreaLeft;
          let toLeft = imageAreaLeft;

          if(imageAreaTop > rectTop || imageAreaBottom < rectBottom){
            toTop = rectTop - (imageAreaHeight / 3);
          }

          if(imageAreaLeft > rectLeft || imageAreaRight < rectRight){
            toLeft = rectLeft - (imageAreaWidth / 3);
          }

          if(fromTop != toTop || fromLeft != toLeft){
            state.isScrolling = true;
            await Common.smoothScroll(fromTop, toTop, fromLeft, toLeft, imageArea);
            state.isScrolling = false;
          }

          // スクロール後の座標をもとにツールボックスを移動
          const baseElemId = `scoring-parent-${state.direction}-${selectedSheetField.value.id}`;
          const toolboxId = "scoring-toolbox";
          autoMoveToolbox(baseElemId, toolboxId, "scoringToolboxLeft", "scoringToolboxTop");
        });
      }
    }

    const scoringToolboxPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 12;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const scoringToolboxPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.scoringToolboxLeft = e.clientX - state.pointerOffsetX;
        state.scoringToolboxTop = e.clientY - state.pointerOffsetY;
      }
    }

    const scoringToolboxPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const scoringToolboxTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const autoMoveToolbox = (baseElemId: string, toolboxId: string, leftPosName: string, topPosName: string) => {
      context.root.$nextTick(() => {
        const baseElem = document.getElementById(baseElemId);
        const toolbox = document.getElementById(toolboxId);

        if(baseElem && toolbox){
          const clientRect = baseElem.getBoundingClientRect();
          // @ts-ignore
          state[leftPosName] = clientRect.left;
          // @ts-ignore
          state[topPosName] = clientRect.top - toolbox.clientHeight - 10;
        }
      });
    }

    /************************************************************
     * 採点モード切り替え AnserImageArea.vueからemitされる
     ************************************************************/
    
    const changeDrawMode = (drawMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedStamp = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    /************************************************************
     * 選択中のテキストスタンプ切り替え AnserImageArea.vueから呼ばれる
     ************************************************************/

    const changeSelectedStamp = (selectedStamp: any) => {
      state.selectedStamp = selectedStamp;
      if(state.selectedStamp && state.selectedStamp.stamp_type == Common.StmapTypeEnum.Text){
        state.fontSize = selectedStamp.font_size;
        state.lineHeight = selectedStamp.line_height;
        state.textColor = selectedStamp.color;
      }
    }

    /************************************************************
     * テキストスタンプ追加 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const addTextStamp = (param: any) => {
      const direction = context.root.$store.state.textDirection;
      const size = Common.getTextSize({fontSize: state.fontSize, lineHeight: state.lineHeight, direction: direction});

      const answerText = new AnswerText();
      answerText.sheet_field_id = selectedSheetField.value.id;
      answerText.idx = selectedSheetField.value.answer_text_idx++;
      answerText.font_size = state.fontSize;
      answerText.line_height = state.lineHeight;
      answerText.color = state.textColor;
      answerText.x = param.point.x;
      answerText.y = param.point.y;
      answerText.width = size.width;
      answerText.height = size.height;
      answerText.direction = direction;
      answerText.base64_text = Common.createBase64Text(answerText);
      selectedSheetField.value.answer_texts.push(answerText);
    }

    /************************************************************
     * テキストスタンプ削除 AnserImageArea.vueから呼ばれる
     ************************************************************/

    const deleteTextStamp = (answerText: AnswerText) => {
      const idx = selectedSheetField.value.answer_texts.indexOf(answerText);
      selectedSheetField.value.answer_texts.splice(idx, 1);
      state.selectedStamp = null;
    }

    /************************************************************
     * 画像スタンプ追加
     ************************************************************/
    const addAnswerImage = (event: any) => {
      
      state.drawMode = DrawModeEnum.None;

      // var files = context.root.$store.state.isMobile ? event.target.files : event.dataTransfer.files;
      const files = event.target.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      const extentions = ["jpg", "jpeg", "heic", "png"];
      const file_work = files[0].name.split('.');
      const extention = file_work[file_work.length - 1].toLowerCase();
      if(!extentions.includes(extention)) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      if(extention == "heic"){
        heic2any({
          blob: files[0],
          toType: 'image/jpeg',
          quality: 1.0
        })
        .then((conversionResult) => {
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = URL.createObjectURL(conversionResult);
        })
        .catch(function(error) {
          console.error(error);
        });
      }else{
        const reader  = new FileReader();
        reader.onload = (e) => {        
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = e.target?.result as string;
        };
        reader.readAsDataURL(files[0]);
      }

      event.target.value = "";
    };

    /************************************************************
     * 画像ファイルロード後
     ************************************************************/

    const imageLoaded = (img: HTMLImageElement, extention: string) => {
      const imageType = extention == "png" ? "image/png" : "image/jpeg"
      let width = img.width;
      let height = img.height;

      let scale = 1;
      const scaleW = (selectedSheetField.value.width - 20) / img.width;
      const scaleH = (selectedSheetField.value.height - 20) / img.height;

      if(scaleW > scaleH){
        // scale = scaleH > 1 ? 1 : scaleH;
        scale = scaleH;
      }else{
        // scale = scaleW > 1 ? 1 : scaleW;
        scale = scaleW
      }

      width *= scale;
      height *= scale;

      // 画像をcanvasに描画した後にbase64文字列に変換
      const canvas = document.createElement("canvas") as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      const base64 = canvas.toDataURL(imageType, 1.0).replace(`data:${imageType};base64,`, "");

      const answerImage = new AnswerImage();
      answerImage.sheet_field_id = selectedSheetField.value.id;
      answerImage.idx = selectedSheetField.value.answer_image_idx++;
      answerImage.x = 30;
      answerImage.y = 30;
      answerImage.width = width * 0.5;
      answerImage.height = height * 0.5;
      answerImage.base64_image = base64;
      selectedSheetField.value.answer_images.push(answerImage);
    }

    /************************************************************
     * 画像スタンプ削除
     ************************************************************/

    const deleteImageStamp = (imageStamp: any) => {
      const idx = selectedSheetField.value.answer_images.indexOf(imageStamp);
      selectedSheetField.value.answer_images.splice(idx, 1);
      state.selectedStamp = null;
    }
    
    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 4;
      state.pointerOffsetY = e.offsetY + 10;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeAnswerText = () => {
      const size = Common.getTextSize({
        text: state.selectedStamp.text,
        fontSize: state.selectedStamp.font_size,
        lineHeight: state.selectedStamp.line_height,
        direction: state.selectedStamp.direction,
      });
      const diffW = size.width - state.selectedStamp.width;
      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        state.selectedStamp.x -= diffW;
      }
      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedStamp.font_size = state.fontSize;
      state.selectedStamp.line_height = state.lineHeight;
      state.selectedStamp.color = state.textColor;
      const size = Common.getTextSize({
        text: state.selectedStamp.text,
        fontSize: state.fontSize,
        lineHeight: state.lineHeight,
        direction: state.selectedStamp.direction,
      });
      const diffW = size.width - state.selectedStamp.width;
      if(state.selectedStamp.direction == DirectionEnum.Vertical){
        state.selectedStamp.x -= diffW;
      }
      state.selectedStamp.width = size.width;
      state.selectedStamp.height = size.height;
      state.selectedStamp.base64_text = Common.createBase64Text(state.selectedStamp);
    }

    const changeTextDirection = (direction: number) => {
      context.root.$store.commit("setTextDirection", direction);
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyDown = (e:KeyboardEvent) => {
      
      // テキスト不可の場合のTショートカットは無効
      if(!state.isTextEnable && e.key == "t"){
        return;
      }

      // 手書き不可の場合のD/Eショートカットは無効
      if(!state.isDrawEnable && (e.key == "d" || e.key == "e")){
        return;
      }
      
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {

      state.keyCode = "";

      // API通信中は処理しない
      if(!state.isShortcutKeyEnable){
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "Backspace" && state.selectedStamp != null){
        if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Text){
          const idx = state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_texts.indexOf(state.selectedStamp);
          state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_texts.splice(idx, 1);
        }else if(state.selectedStamp.stamp_type == Common.StmapTypeEnum.Image){
          const idx = state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_images.indexOf(state.selectedStamp);
          state.pageItems[state.selectedAnswerPageIdx].sheet_fields[state.selectedFieldIdx].answer_images.splice(idx, 1);
        }
        
        state.selectedStamp = null;
      }
    }

    /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const remainingTimeText = computed((): string => {
      // ミリ秒からdurationオブジェクトを生成
      const duration = moment.duration(state.remainingTime);
      
      // 日・時・分・秒を取得
      const days = Math.floor(duration.asDays());
      const hours   = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      // カウントダウンの結果を変数に代入
      if(days > 0){
        return '残り時間：' + days + '日' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(hours > 0){
        return '残り時間：' +  hours + '時間' + minutes + '分' + seconds + '秒';
      }else if(minutes > 0){
        return '残り時間：' +  minutes + '分' + seconds + '秒';
      }else{
        return '残り時間：' +  seconds + '秒';
      }
    });

    /************************************************************
     * 残り時間・画面表示用文字列
     ************************************************************/

    const timeOverAlertText = computed(() => {
      if(state.sheet.sheet_type == Common.SheetTypeEnum.Homework){
        return `${Common.formatDate(state.sheet.test_end_datetime_at, "k時m分締切りです。")}`;
      }else{
        return `${Common.formatDate(state.sheet.test_end_datetime_at, "k時m分に試験が終了します")}`;
      }
    });

    /************************************************************
     * 保存
     ************************************************************/

    const save = async () => {

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("status", state.status.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/save`, fd).then(() => {
          Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
          state.errors = [];
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * 自己採点保存
     ************************************************************/

    const saveCorrectState = async () => {
      
      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      const param: any = {};
      param["sheet_id"] = state.sheet.id;
      param["status"] = state.status;
      param["param_sheet_fields"] = sheetFields.map(x => new ParamSheetField(x));

      if(state.fromStudentSheetList){
        param["student_no_character"] = context.root.$store.state.student_no_character;
      }else{
        param["email"] = context.root.$store.state.digitalPaperEmail;
      }

      await http.post(`/api/digital_paper/answer_input/save_correct_state`, param).then(() => {
        Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 解答登録
     ************************************************************/

    const entryAnswer = async () => {

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "解答を確定します。確定後は変更できません。よろしいですか？")){
        return;
      }

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      if(sheetFields.filter(x => !x.isKaitouCompleted).length > 0){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未解答の設問がありますが、よろしいですか？")){
          return;
        }
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/entry_answer`, fd).then(async () => {
          await Common.customAlert(context.root.$bvModal, context.root.$store, "処理が完了しました。\n自己採点をして提出してください。");
          state.errors = [];
          state.status = StudentSheetStatusEnum.SelfScoring;
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.sheet.question_image_completed;
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * 提出
     ************************************************************/

    const entry = async () => {

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "答案を提出します。よろしいですか？")){
        return;
      }

      let sheetFields = new Array<SheetField>();
      state.pageItems.forEach(x => sheetFields = sheetFields.concat(x.sheet_fields));

      if(state.sheet.is_self_scoring_enable){
        if(sheetFields.filter(x => x.kind == 0 && x.correct_state == null).length > 0){
          if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "自己採点未完了の設問がありますが、提出してよろしいですか？")){
            return;
          }
        }
      }else{
        if(sheetFields.filter(x => !x.isKaitouCompleted).length > 0){
          if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未解答の設問がありますが、提出してよろしいですか？")){
            return;
          }
        }
      }

      context.root.$store.dispatch("showOverlay");
      state.isShortcutKeyEnable = false;

      // canvas・解答文字画像をZip化
      let zip = new jsZip();
      sheetFields.forEach(x => {
        if(x.is_canvas_updated){
          zip.file(`${x.id}.png`, x.base64_canvas, {base64: true});
        }
        x.answer_texts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
          zip.file(`answer_text_${y.sheet_field_id}_${y.idx}.png`, y.base64_text, {base64: true});
        });
        x.answer_images.forEach(y => {
          zip.file(`answer_image_${y.sheet_field_id}_${y.idx}.jpg`, y.base64_image, {base64: true});
        });
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("sheet_id", state.sheet.id.toString());
        fd.append("param_sheet_fields", JSON.stringify(sheetFields.map(x => new ParamSheetField(x))));

        if(state.fromStudentSheetList){
          fd.append("student_no_character", context.root.$store.state.student_no_character);
        }else{
          fd.append("email", context.root.$store.state.digitalPaperEmail);
        }

        await http.post(`/api/digital_paper/answer_input/entry`, fd).then(async () => {
          await Common.customAlert(context.root.$bvModal, context.root.$store, "処理が完了しました。");
          state.errors = [];
          window.history.back();
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });

      context.root.$store.dispatch("hideOverlay");
      state.isShortcutKeyEnable = true;
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      state.fromStudentSheetList = !context.root.$route.path.includes("digital_paper_site");

      let param = `sheet_id=${context.root.$route.params.sheet_id}`;
      if(state.fromStudentSheetList){
        param += `&student_no_character=${context.root.$store.state.student_no_character}`
      }else{
        param += `&email=${context.root.$store.state.digitalPaperEmail}`
      }

      await http.get(`/api/digital_paper/answer_input?${param}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.base64QuestionImages = response.data.base64_question_images;
        state.base64CorrectImages = response.data.base64_correct_images;
        state.before_student_sheet_id = response.data.before_student_sheet_id;
        state.cutMargin = response.data.cut_margin;
        state.status = response.data.status;
        state.questionImageDiscriptions = response.data.question_image_discriptions;
        for(let i = 0; i < state.sheet.page_count; i++){
          state.pageItems.push(new PageItem(i + 1, response.data.base64_answer_images[i], response.data.sheet_fields, response.data.anwser_image_size_hashes[i].width, response.data.anwser_image_size_hashes[i].height));
        }
        
        state.pageItems.forEach(pageItem => {
          pageItem.sheet_fields.forEach(sheet_field => {
            const self_scoring = response.data.self_scorings.find((x: any) => x.sheet_field_id == sheet_field.id)
            if(self_scoring){
              sheet_field.correct_state = self_scoring.correct_state;
            }
          });
        });

        state.isTextEnable = [Common.DigialAnswerTypeEnum.Both, Common.DigialAnswerTypeEnum.Text, Common.DigialAnswerTypeEnum.Image].includes(state.sheet.digital_answer_type);
        state.isDrawEnable = [Common.DigialAnswerTypeEnum.Both, Common.DigialAnswerTypeEnum.Draw, Common.DigialAnswerTypeEnum.Image].includes(state.sheet.digital_answer_type);
        state.isImageEnable = [Common.DigialAnswerTypeEnum.Both, Common.DigialAnswerTypeEnum.Image].includes(state.sheet.digital_answer_type);
        const colorWidth = state.isColorEnable ? 0 : 25;

        // if(state.isTextEnable && state.isDrawEnable){
        //   state.modeAreaWidth = 315 - colorWidth;
        // }else if(state.isTextEnable){
        //   state.modeAreaWidth = 115;
        // }else if(state.isDrawEnable){
        //   state.modeAreaWidth = 230 - colorWidth;
        // }

        if(state.status >= StudentSheetStatusEnum.SelfScoring){
          state.previewImageType = PreviewImageTypeEnum.Correct;
          state.isDispToggre = state.sheet.question_image_completed;
        }else if(state.sheet.question_image_completed){
          state.previewImageType = PreviewImageTypeEnum.Question;
          state.isDispToggre = false;
        }
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      // state.drawMode = context.root.$store.state.isMobile ? DrawModeEnum.FreeLine : DrawModeEnum.None;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
        if(!context.root.$store.state.is_preview_mode){
          // 選択設問の初期値 1ページ目の先頭の設問or署名
          let selectedFieldIdx = 0;

          // 自己採点モードの場合は先頭の設問を表示 設問が存在しない場合は未選択
          if(state.status == StudentSheetStatusEnum.SelfScoring){
            const setsumonSheetFields = state.pageItems[state.selectedAnswerPageIdx].sheet_fields.filter(x => x.kind == Common.SheetFieldKindEnum.FIELD);
            selectedFieldIdx = setsumonSheetFields.length == 0 ? 0 : state.pageItems[state.selectedAnswerPageIdx].sheet_fields.indexOf(setsumonSheetFields[0]);
          }
          changeSelectedSheetField(selectedFieldIdx);
          // state.drawMode = state.isDrawEnable ? DrawModeEnum.FreeLine : DrawModeEnum.Text;
        }
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);

      // 終了日時が設定されている場合はタイマー起動
      if(state.sheet.test_end_datetime_at){
        state.timer = setInterval(async () => {

          // 現在日時取得
          var now = Date.now();

          // テスト終了日時から現在日時を減算し、残り時間を求める
          state.remainingTime = (state.sheet.test_end_datetime_at.getTime() - now);

          // 残り時間があるか判定
          if(!state.isTimeOver && state.remainingTime <= 0){
            // 解答操作をOFFにして提出操作のみ可能にする
            state.isTimeOver = true;
            state.isRemainingTimeDisp = false;
            state.isTimeOverAlertDisp = false;
            state.selectedFieldIdx = null;
            state.selectedStamp = null;

            // タイマー停止
            clearInterval(state.timer);
            
            if(state.sheet.sheet_type == Common.SheetTypeEnum.Homework){
              await Common.customAlert(context.root.$bvModal, context.root.$store, `課題は締め切られました。提出ボタンを押して提出してください。`);
            }else if(state.sheet.is_self_scoring_enable){
              state.status = StudentSheetStatusEnum.SelfScoring;
              state.previewImageType = PreviewImageTypeEnum.Correct;
              state.isDispToggre = state.sheet.question_image_completed;
              await Common.customAlert(context.root.$bvModal, context.root.$store, `試験が終了しました。自己採点をして提出してください。`);
            }else{
              await Common.customAlert(context.root.$bvModal, context.root.$store, `試験が終了しました。提出ボタンを押して提出してください。`);
            }
          }else if(!state.isRemainingTimeDisp && state.remainingTime < 1 * 60 * 1000){
            // 残り1分でタイマー表示
            state.isRemainingTimeDisp = true;
          }else if(!state.isTimeOverAlertDisp && state.remainingTime < 5 * 60 * 1000){
            // 残り5分で終了間近のお知らせ表示
            state.isTimeOverAlertDisp = true;
          }
        }, 200);
      }
      
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      if(state.timer){
        clearInterval(state.timer);
      }
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      DirectionEnum,
      StmapTypeEnum,
      horizonAnswerImageAreaRef,
      verticalAnswerImageAreaRef,
      horizonQuestionImageAreaRef,
      horizonCorrectImageAreaRef,
      verticalQuestionImageAreaRef,
      verticalCorrectImageAreaRef,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      horizonModeTopHeight,
      horizonModeBottomHeight,
      changeDirection,
      answerSheetPageChanged,
      questionSheetPageChanged,
      correctImagePageChanged,
      changeSelectedSheetField,
      selectedSheetField,
      selectedTextDirection,
      save,
      saveCorrectState,
      entry,
      entryAnswer,
      changeDrawMode,
      changeSelectedStamp,
      addTextStamp,
      deleteTextStamp,
      deleteImageStamp,
      changeAnswerText,
      textFormatChanged,
      changeTextDirection,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      downloadResultPdf,
      keyDown,
      keyUp,
      changeDrawModeFromChild,
      rootTouchmove,
      remainingTimeText,
      timeOverAlertText,
      selectedStampElemId,
      isScoringToolBoxVisible,
      changeCorrectState,
      scoringToolboxPointerDown,
      scoringToolboxPointerMove,
      scoringToolboxPointerUp,
      scoringToolboxTouchMove,
      changeImageType,
      addAnswerImage,
     };
  }
})
